import "./tripplanner.css";

const TripPlannerBackground = ({ children }) => {
 
  return (
    <div class="background" id="trip-planner">
      {children}
    </div>
  );
};

export default TripPlannerBackground;